import Transform from "@ember-data/serializer/transform";

export default class ImmunotherapiesTransform extends Transform {
  override deserialize(serialized) {
    serialized?.forEach(immunotherapy => {
      // Make sure date are of type Date and not string.
      // This is useful when passing the date in a DatePicker, which must have a Date and not a string.
      if (immunotherapy.startDate) {
        immunotherapy.startDate = new Date(immunotherapy.startDate);
      }
      if (immunotherapy.endDate) {
        immunotherapy.endDate = new Date(immunotherapy.endDate);
      }
      if (immunotherapy.consultation) {
        immunotherapy.consultation = new Date(immunotherapy.consultation);
      }
    });
    return serialized;
  }

  override serialize(deserialized) {
    return deserialized;
  }
}

declare module "ember-data/types/registries/transform" {
  export default interface TransformRegistry {
    immunotherapies: ImmunotherapiesTransform;
  }
}
